import React from "react";

const LAYERS = [0, 1, 2, 3, 4, 5];

export const LogoOrbitBg = () => (
  <div className="lob-root" aria-hidden="true" data-testid="muestras-logo-bg">
    <div className="lob-glow lob-glow-a" />
    <div className="lob-glow lob-glow-b" />
    <div className="lob-grid" />
    <div className="lob-stage">
      <div className="lob-logo">
        {LAYERS.map((i) => (
          <img
            key={i}
            src="/logo-symbol-light.png"
            alt=""
            draggable={false}
            className={i === LAYERS.length - 1 ? "lob-face" : "lob-depth"}
            style={{ transform: `translateZ(${i * 6}px)` }}
          />
        ))}
      </div>
      <div className="lob-shadow" />
    </div>
  </div>
);
